import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { InfoPageRoutingModule } from "./info-routing.module";

import { InfoPage } from "./info.page";
import { TranslateModule } from "@ngx-translate/core";
import { SanitizeHtmlPipe } from "../../_common/pipes/SanitizeHtml";
import { HeaderModule } from "../../_component/header/header.module";
import { ImagePreviewModule } from "../_component/image-preview/image-preview.module";
import { SharedDirectivesModule } from "../../_directives/shared-directives.module";
import { NoResultModule } from "../_component/no-result/no-result.module";
import { LoadingStiModule } from "../../_component/loading-sti/loading-sti.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    InfoPageRoutingModule,
    HeaderModule,
    ImagePreviewModule,
    SharedDirectivesModule,
    NoResultModule,
    LoadingStiModule,
  ],
  declarations: [InfoPage, SanitizeHtmlPipe],
  exports: [SanitizeHtmlPipe],
})
export class InfoPageModule {}
